import { useState } from 'react';
import { useEffect } from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import { upsertMasterDataLoadType } from '../../apiCalls';
import { Input } from '../../Input/Input';

const LoadModal = ({ onSave, onCancel, load, onError }) => {
  const [localLoad, setLocalLoad] = useState({});

  useEffect(() => {
    setLocalLoad(load);
  }, [load]);

  async function submitForm(event) {
    event.preventDefault();
    try {
      const isNew = localLoad.id === -1;
      const payload = {
        id: isNew ? null : localLoad.id,
        loadType: localLoad.loadType || localLoad.type,
        PackageCode: localLoad.PackageCode || '',
        CDSPackageCode: localLoad.CDSPackageCode || '',
        softDelete: 0,
      };

      await upsertMasterDataLoadType(payload);
      onSave(isNew);
      onCancel();
    } catch (err) {
      console.log(err);
      if (onError) onError(err.message || 'Failed to save package type');
    }
  }

  return (
    <Modal
      show={localLoad?.id !== undefined}
      onHide={onCancel}
      centered
      size="lg"
      contentClassName="editModal"
      dialogClassName="wide-modal"
    >
      <Modal.Header>
        <Modal.Title>Editing: {localLoad?.loadType || localLoad?.type}</Modal.Title>{' '}
        <button type="button" class="btn-close" aria-label="Close" onClick={onCancel} />
      </Modal.Header>
      <Form onSubmit={submitForm} className="flex-grow-1 d-flex flex-column">
        <Modal.Body className="flex-grow-1">
          <Row>
            <Col>
              <Input
                name="loadType"
                type="text"
                label="Package Type"
                required
                value={localLoad?.loadType || localLoad?.type || ''}
                onChange={(e) => setLocalLoad((prev) => ({ ...prev, loadType: e.target.value }))}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Input
                name="PackageCode"
                type="text"
                label="Thyme-IT Package Code"
                value={localLoad?.PackageCode || ''}
                onChange={(e) => setLocalLoad((prev) => ({ ...prev, PackageCode: e.target.value }))}
                maxLength="2"
              />
            </Col>
            <Col>
              <Input
                name="CDSPackageCode"
                type="text"
                label="Descartes Package Code"
                value={localLoad?.CDSPackageCode || ''}
                onChange={(e) => setLocalLoad((prev) => ({ ...prev, CDSPackageCode: e.target.value }))}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer
          class="d-flex flex-row py-3 px-3 gap-3 border-top bg-light justify-content-end align-items-center"
          style={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}
        >
          <button
            type="button"
            class="cancel-button"
            onClick={onCancel}
            style={{ display: 'flex', borderRadius: '10px' }}
          >
            Cancel
          </button>
          <button type="submit" class="blue-button-teams green-btn" style={{ borderRadius: '10px' }}>
            Save
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export default LoadModal;
